export const popupMotion = {
	variants: {
		init: {
			opacity: 0,
			y: '-5%',
		},
		animate: {
			opacity: 1,
			y: 0,
		},
		exit: {
			opacity: 0,
			y: '-5%',
		},
	},
	transition: {
		duration: 0.25,
	},
};
